import ColumnChart from '../../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function AverageTickets ({ data }) {
  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const averageTickets = [
    ['Mês', 'Ticket médio'],
    ...Object.entries (data).map (([month, values]) => [
      month, Number (values.avgTicket) || 0,
    ])
  ]

  return (
    <InfoContainer>
      <SubTitle>Tickets médios</SubTitle>
      <ColumnChart
        data={averageTickets}
        legendPosition='top'
        options={{
          isStacked: false,
          height: 350,
          legend: 'none',
          colors: ['#35A7FF'],
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Valor (R$)',
            minValue: 0,
            titleTextStyle: {
              bold: true
            }
          }
        }}
      />
    </InfoContainer>
  )
}
